// extracted by mini-css-extract-plugin
export default {"disabled":"clickableDiv_disabled__FmgO-"};